const PENDING_CLOUDPAYMENT_INVOICE_KEY = 'pendingCloudPaymentInvoiceId';

/**
 * Save pending payment invoiceId to localStorage
 */
export const savePendingInvoiceId = (invoiceId: string): void => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(PENDING_CLOUDPAYMENT_INVOICE_KEY, invoiceId);
  } catch (error) {
    console.error('[CloudPayments] Error saving pending invoiceId:', error);
  }
};

/**
 * Get pending payment invoiceId from localStorage
 */
export const getPendingInvoiceId = (): string | null => {
  if (typeof window === 'undefined') return null;

  try {
    return localStorage.getItem(PENDING_CLOUDPAYMENT_INVOICE_KEY);
  } catch (error) {
    console.error('[CloudPayments] Error getting pending invoiceId:', error);
    return null;
  }
};

/**
 * Remove pending payment invoiceId from localStorage
 */
export const removePendingInvoiceId = (): void => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.removeItem(PENDING_CLOUDPAYMENT_INVOICE_KEY);
  } catch (error) {
    console.error('[CloudPayments] Error removing pending invoiceId:', error);
  }
};
